// @ts-strict-ignore
import { faTimes } from "@fortawesome/pro-light-svg-icons";
import { useRef, type ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { l } from "@clinic/shared/locales/i18n";
import { useOutsideClick } from "@shared/hooks/useOutsideClick/useOutsideClick";
import { FontAwesomeIcon } from "@shared/react-fontawesome/react-fontawesome";

import * as styles from "./EmersonSidebarItems.styles";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
}

const EmersonSidebarItems = ({ children, isOpen, onClose }: Props) => {
  const { t } = useTranslation("common");
  const ref = useRef<HTMLDivElement>(null);
  useOutsideClick(ref, () => {
    if (isOpen) {
      onClose();
    }
  });

  return (
    <div css={styles.fullHeight} ref={ref}>
      <div css={styles.header}>
        <span
          onClick={onClose}
          data-testid="close-link"
          tabIndex={0}
          aria-label={t(l.common.CloseModal)}
        >
          <FontAwesomeIcon size="xl" css={styles.close} icon={faTimes} />
        </span>
      </div>
      <div css={styles.fullHeight}>{children}</div>
    </div>
  );
};

export { EmersonSidebarItems };
